import env from '../env/env.json';


function PublishEvent(filename, formData) {
    const APIEndPoint = env.publicApi + 'event/'
    const fixData = filterData(formData)
    const publish = async (filename, fixData) => {
        //event.preventDefault();

        try {
          //console.log("Call : " + APIEndPoint + filename)
          const response = await fetch(APIEndPoint + filename, {
            method: 'PUT',
            headers: {
              "X-API-Key": env.publicKey,
              "ClientKey": "bb3893e1-be40-4db9-ba11-cee8038066fa",
              "Content-Type": "application/json"
            },
            body: JSON.stringify(fixData)
          });
          
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          
          //console.log('Response:', response.status);
          return { status: response.status, data: null }
        } catch (error) {
          console.error('Erreur:', error);
          return error
        }
    };
    return publish(filename, fixData)
}


function filterData(formData) {
  const newData = {};
  Object.keys(formData).forEach(key => {
    let value = formData[key]
    if (value !== null && value !== undefined && (typeof value === 'string' || value instanceof String)) {
      //A key to just trim
      value = value.trim()
    }
    newData[key] = value
  })
  return newData
}

export default PublishEvent